/* eslint-disable camelcase */
import Model from './Model';

class InvitedUser extends Model {
    static fields() {
        return {
            id: String,
            firstname: String,
            lastname: String,
            middlename: String,
            full_name: String,
            dob: String,
            email: String,
            inviter_id: String,
            status: String,
            is_bank_added: String,
            is_identity_verified: String,
            token: String,
            last_transaction_created_at: String,
            joined_at: String,
            created_at: String,
            updated_at: String,
        };
    }

    /**
     * Get extended status of user
     */
    get extendedStatus() {
        if (this.joined_at) {
            if (this.last_transaction_created_at && this.status !== 'new') {
                if (this.status === 'banned') {
                    return 'registered';
                }
                return this.status;
            }
            return 'registered';
        }
        return 'invited';
    }
}

export default InvitedUser;
